export {
  BUSINESS_STATUS_ENUM,
  BUSINESS_STATUS,
  quantity as Quantity
} from "@/fnss-lib/enums/index";

// 入库质押
export const InPledgeState = {
  INIT_STATE: 0, //, "初始化状态"),
  IN_STORAGE_STATE: 10, //, "入库"),//小雪或者是其他对接方
  INSPECTION_FINISH_STATE: 20, //, "尽调验货完成"),
  CONFIRM_CAPITAL_STATE: 30, //, "合同主体确认"),
  SUCCESS_STATE: 40, //, "成功"),
  FAIL_STATE: 50 //, "失败");
};

export const period = [
  { key: "1", value: "一个月" },
  { key: "2", value: "二个月" },
  { key: "3", value: "三个月" },
  { key: "4", value: "四个月" },
  { key: "5", value: "五个月" },
  { key: "6", value: "六个月" }
];

export const periodMap = (() => {
  let map = {};
  period.forEach(p => {
    map[p.key] = p.value;
  });
  return map;
})();

// 意向状态
export const IntensionState = {
  /** 初始化状态 */
  INIT_STATE: 0,
  INSPECTOR_APPLY_STATE: 10, // "尽调申请"),
  SUCCESS_STATE: 20, // "成功"),
  FAIL_STATE: 30, // "失败"),
  INSPECTOR_ASSIGN: 40 // "尽调指派");
};

export const TON_TO_JIN = 2000;
